<template>
  <div>
    <slot v-if="showItem" name="item" />
    <v-skeleton-loader v-else v-bind="$attrs" />
  </div>
</template>

<script>
export default {
  props: {
    showItem: {
      type: [Boolean, Object]
    }
  }
}
</script>

<style scoped>
</style>
